export function assetUrl(path: string, { versioned = true }: { versioned?: boolean } = {}) {
  const base = import.meta.env.BASE_URL || "/";
  const cleanPath = path.replace(/^\/+/, "");
  const url = `${base}${cleanPath}`;

  if (!versioned) {
    return url;
  }

  const separator = url.includes("?") ? "&" : "?";
  return `${url}${separator}v=${encodeURIComponent(__PUBLIC_ASSET_VERSION__)}`;
}
